export default function TenantInfo({rms}){
    return (
        <>
          <div className="card-box" style={{ marginBottom: '10px' }}>
                        <h4 className="header-title mb-0" style={{ padding: '3px', fontSize: '12px', paddingBottom: '10px' }}>Tenant Info</h4>
                        <hr style={{ marginTop: '0px', marginBottom: '3px' }} />
                        <table className="table table-striped table-bordered table-centered mb-0  mt-1 alarm_table_custom">
                            <thead className="toi-primary text-white">
                                <tr>
                                    <th className="text-center fw-bold">Tenant</th>
                                    <th className="text-center fw-bold">On Air</th>
                                    <th className="text-center fw-bold" title="Critical">CC(A)</th>
                                    <th className="text-center fw-bold" title="Non-Critical">NC(A)</th>
                                    <th className="text-center fw-bold" title="Voltage">Volt(V)</th>

                                </tr>
                            </thead>
                            <tbody>
                                {rms?.dc_energy_meter.length > 0 && rms?.dc_energy_meter.map((tenant, index) => (
                                    <tr className>
                                        <td className="fw-bold">{tenant.tenant_name}</td>
                                        <td className="text-center fw-medium">{tenant.on_air_date}</td>
                                        <td className="text-center fw-medium">{tenant.acur}</td>
                                        <td className="text-center fw-medium">{tenant.bcur}</td>
                                        <td className="text-center fw-medium">{tenant.voltage}</td>
                                    </tr>
                                ))}
                             
                            </tbody>
                        </table>
                    </div>
        </>
    )
}